
export type GetUserThreads200ItemCurrentUserStatusStatus = typeof GetUserThreads200ItemCurrentUserStatusStatus[keyof typeof GetUserThreads200ItemCurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserThreads200ItemCurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
